var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        (function () {
            var ReviewsPage = function () {
                function ReviewsPage(root) {
                    _classCallCheck(this, ReviewsPage);

                    this.root = root;
                    this.listUrl = root.dataset.listUrl || '';
                    this.countrySlug = root.dataset.countrySlug || '';
                    this.stars = root.dataset.stars || '';
                    this.tourists = root.dataset.tourists || '';
                    this.offset = Number(root.dataset.offset || 0);
                    this.limit = Number(root.dataset.limit || 10);
                    this.total = Number(root.dataset.total || 0);

                    this.filtersWrapElement = root.querySelector('.js-reviews-filters-wrap');
                    this.listElement = root.querySelector('.js-reviews-list');
                    this.loadingElement = root.querySelector('.js-reviews-loading');
                    this.loadingProgressFillElement = root.querySelector('.js-reviews-loading-progress-fill');
                    this.triggerElement = root.querySelector('.js-reviews-load-trigger');
                    this.endElement = root.querySelector('.js-reviews-end');
                    this.emptyElement = root.querySelector('.js-reviews-empty');

                    this.hasMore = this.offset < this.total;
                    this.isLoading = false;
                    this.observer = null;
                    this.lazyImageObserver = null;
                    this.loadingProgressFrameId = null;
                    this.loadingProgressStartedAt = 0;

                    this.initFilters();
                    this.syncUiFilterWidgets();
                    this.initInfiniteLoad();
                    this.initLazyImageObserver();
                    this.observeLazyImages(this.root);
                    this.updateLoadState();
                    this.updateEmptyState();
                }

                _createClass(ReviewsPage, [{
                    key: "syncUiFilterWidgets",
                    value: function syncUiFilterWidgets() {
                        var filtersRoot = this.filtersWrapElement || this.root;

                        if (window.uiSelectWidget && typeof window.uiSelectWidget.initState === 'function') {
                            window.uiSelectWidget.initState();
                        }

                        if (window.UiSelectSlider && typeof window.UiSelectSlider.initAll === 'function') {
                            window.UiSelectSlider.initAll(filtersRoot);
                        }
                    }
                }, {
                    key: "initFilters",
                    value: function initFilters() {
                        var root = this.root;

                        root.addEventListener('click', function (event) {
                            var link = event.target.closest('.reviews-filter__item');
                            if (!link) {
                                return;
                            }

                            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
                                return;
                            }

                            var href = link.getAttribute('href');
                            if (!href) {
                                return;
                            }

                            event.preventDefault();
                            this.applyFilterSelectionImmediately(link);
                            this.closeOpenedFilters();
                            this.applyFiltersFromUrl(href);
                        }.bind(this));

                        root.addEventListener('click', function (event) {
                            var target = event.target.closest('.js-reviews-filter-toggle');
                            if (!target) {
                                return;
                            }

                            event.preventDefault();
                            event.stopPropagation();

                            var filterContainer = target.closest('.js-reviews-filter');
                            if (!filterContainer) {
                                return;
                            }

                            var menuId = target.dataset.target;
                            var menu = menuId ? document.getElementById(menuId) : null;
                            if (!menu) {
                                return;
                            }

                            Array.prototype.forEach.call(root.querySelectorAll('.reviews-filter__menu.is-open'), function (menuItem) {
                                if (menuItem !== menu) {
                                    menuItem.classList.remove('is-open');
                                }
                            });

                            Array.prototype.forEach.call(root.querySelectorAll('.reviews-filter.is-open'), function (filter) {
                                if (filter !== filterContainer) {
                                    filter.classList.remove('is-open');
                                }
                            });

                            var willOpen = !menu.classList.contains('is-open');
                            menu.classList.toggle('is-open', willOpen);
                            filterContainer.classList.toggle('is-open', willOpen);
                        });

                        document.addEventListener('click', function (event) {
                            if (event.target.closest('.js-reviews-filter')) {
                                return;
                            }

                            Array.prototype.forEach.call(root.querySelectorAll('.reviews-filter__menu.is-open'), function (menu) {
                                menu.classList.remove('is-open');
                            });
                            Array.prototype.forEach.call(root.querySelectorAll('.reviews-filter.is-open'), function (filter) {
                                filter.classList.remove('is-open');
                            });
                        });

                        root.addEventListener('ui-select:change', function (event) {
                            var select = event.target.closest('.ui-select');
                            if (!select || !select.closest('.js-reviews-filters-select-slider')) {
                                return;
                            }

                            var detail = event.detail || {};
                            this.applyUiSelectFilter(detail.widgetId || '', detail.value || '');
                        }.bind(this));
                    }
                }, {
                    key: "closeOpenedFilters",
                    value: function closeOpenedFilters() {
                        var root = this.root;

                        Array.prototype.forEach.call(root.querySelectorAll('.reviews-filter__menu.is-open'), function (menu) {
                            menu.classList.remove('is-open');
                        });
                        Array.prototype.forEach.call(root.querySelectorAll('.reviews-filter.is-open'), function (filter) {
                            filter.classList.remove('is-open');
                        });
                    }
                }, {
                    key: "applyFilterSelectionImmediately",
                    value: function applyFilterSelectionImmediately(link) {
                        var menu = link.closest('.reviews-filter__menu');
                        if (menu) {
                            Array.prototype.forEach.call(menu.querySelectorAll('.reviews-filter__item.is-active'), function (item) {
                                item.classList.remove('is-active');
                            });
                            link.classList.add('is-active');
                        }

                        var filter = link.closest('.js-reviews-filter');
                        if (!filter) {
                            return;
                        }

                        var labelElement = filter.querySelector('.reviews-filter__label');
                        if (!labelElement) {
                            return;
                        }

                        var firstSpan = link.querySelector('span');
                        var labelValue = firstSpan ? firstSpan.textContent : link.textContent;
                        labelElement.textContent = (labelValue || '').trim();
                    }
                }, {
                    key: "initInfiniteLoad",
                    value: function initInfiniteLoad() {
                        if (!this.triggerElement || !this.hasMore) {
                            return;
                        }

                        if ('IntersectionObserver' in window) {
                            this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
                                root: null,
                                rootMargin: '300px 0px',
                                threshold: 0
                            });
                            this.observer.observe(this.triggerElement);
                            return;
                        }

                        window.addEventListener('scroll', this.handleScrollFallback.bind(this));
                    }
                }, {
                    key: "initLazyImageObserver",
                    value: function initLazyImageObserver() {
                        if (!('IntersectionObserver' in window)) {
                            return;
                        }

                        this.lazyImageObserver = new IntersectionObserver(function (entries, observer) {
                            entries.forEach(function (entry) {
                                if (!entry.isIntersecting) {
                                    return;
                                }

                                var image = entry.target;
                                if (image.dataset && image.dataset.src) {
                                    image.src = image.dataset.src;
                                }

                                image.classList.remove('lazy-img-watch');
                                observer.unobserve(image);
                            });
                        });
                    }
                }, {
                    key: "observeLazyImages",
                    value: function observeLazyImages(parent) {
                        if (!parent) {
                            return;
                        }

                        var images = parent.querySelectorAll('img.lazy-img-watch[data-src]');
                        if (!images.length) {
                            return;
                        }

                        if (this.lazyImageObserver) {
                            Array.prototype.forEach.call(images, function (image) {
                                this.lazyImageObserver.observe(image);
                            }.bind(this));
                            return;
                        }

                        Array.prototype.forEach.call(images, function (image) {
                            image.src = image.dataset.src;
                            image.classList.remove('lazy-img-watch');
                        });
                    }
                }, {
                    key: "handleIntersection",
                    value: function handleIntersection(entries) {
                        if (!entries.length) {
                            return;
                        }

                        if (entries[0].isIntersecting) {
                            this.loadMore();
                        }
                    }
                }, {
                    key: "handleScrollFallback",
                    value: function handleScrollFallback() {
                        if (!this.triggerElement) {
                            return;
                        }

                        var triggerTop = this.triggerElement.getBoundingClientRect().top;
                        if (triggerTop < window.innerHeight + 300) {
                            this.loadMore();
                        }
                    }
                }, {
                    key: "applyFiltersFromUrl",
                    value: function applyFiltersFromUrl(urlString) {
                        this.applyFiltersState(this.parseStateFromUrl(urlString));
                    }
                }, {
                    key: "applyUiSelectFilter",
                    value: function applyUiSelectFilter(widgetId, value) {
                        var state = {
                            countrySlug: this.countrySlug,
                            stars: this.stars,
                            tourists: this.tourists
                        };

                        if (widgetId === 'reviews-country-filter') {
                            state.countrySlug = value;
                        } else if (widgetId === 'reviews-stars-filter') {
                            state.stars = value;
                        } else if (widgetId === 'reviews-tourists-filter') {
                            state.tourists = value;
                        } else {
                            return;
                        }

                        this.applyFiltersState(state);
                    }
                }, {
                    key: "applyFiltersState",
                    value: function applyFiltersState(state) {
                        if (this.isLoading) {
                            return;
                        }

                        var nextCountrySlug = state.countrySlug || '';
                        var nextStars = state.stars || '';
                        var nextTourists = state.tourists || '';

                        if (nextCountrySlug === this.countrySlug && nextStars === this.stars && nextTourists === this.tourists) {
                            return;
                        }

                        this.countrySlug = nextCountrySlug;
                        this.stars = nextStars;
                        this.tourists = nextTourists;
                        this.offset = 0;
                        this.total = 0;
                        this.hasMore = true;

                        this.showReplacingState();
                        this.fetchReviews(true);
                    }
                }, {
                    key: "parseStateFromUrl",
                    value: function parseStateFromUrl(urlString) {
                        var url = new URL(urlString, window.location.origin);
                        var segments = url.pathname.replace(/^\/+|\/+$/g, '').split('/').filter(Boolean);

                        var reviewsIndex = segments.indexOf('reviews');
                        var countrySlug = '';
                        if (reviewsIndex !== -1) {
                            countrySlug = segments[reviewsIndex + 1] || '';
                        }

                        return {
                            countrySlug: countrySlug,
                            stars: url.searchParams.get('stars') || '',
                            tourists: url.searchParams.get('tourists') || ''
                        };
                    }
                }, {
                    key: "fetchReviews",
                    value: function fetchReviews(isReplace) {
                        if (this.isLoading || !this.listUrl) {
                            return;
                        }

                        this.isLoading = true;
                        if (this.loadingElement) {
                            this.loadingElement.classList.remove('is-hidden');
                        }
                        this.startLoadingProgress();

                        var params = new URLSearchParams();
                        if (this.countrySlug) {
                            params.set('countrySlug', this.countrySlug);
                        }
                        if (this.stars) {
                            params.set('stars', this.stars);
                        }
                        if (this.tourists) {
                            params.set('tourists', this.tourists);
                        }

                        params.set('offset', String(this.offset));
                        params.set('limit', String(this.limit));

                        fetch(this.listUrl + '?' + params.toString(), {
                            method: 'GET',
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest'
                            }
                        }).then(function (response) {
                            return response.json();
                        }).then(function (data) {
                            if (!data || !data.success) {
                                return;
                            }

                            if (isReplace) {
                                this.listElement.innerHTML = data.html || '';
                                this.observeLazyImages(this.listElement);
                            } else if (data.html) {
                                this.listElement.insertAdjacentHTML('beforeend', data.html);
                                this.observeLazyImages(this.listElement);
                            }

                            this.offset = Number(data.offset || this.offset);
                            this.total = Number(data.total || this.total);
                            this.hasMore = !!data.hasMore;

                            this.root.dataset.countrySlug = this.countrySlug;
                            this.root.dataset.stars = this.stars;
                            this.root.dataset.tourists = this.tourists;
                            this.root.dataset.offset = String(this.offset);
                            this.root.dataset.total = String(this.total);

                            this.updateLoadState();
                            this.updateEmptyState();
                        }.bind(this)).catch(function () {
                            if (isReplace && this.listElement) {
                                this.listElement.classList.remove('is-hidden');
                            }
                            this.updateLoadState();
                        }.bind(this)).finally(function () {
                            if (isReplace) {
                                this.hideReplacingState();
                            }
                            this.isLoading = false;
                            this.stopLoadingProgress();
                            if (this.loadingElement) {
                                this.loadingElement.classList.add('is-hidden');
                            }
                        }.bind(this));
                    }
                }, {
                    key: "showReplacingState",
                    value: function showReplacingState() {
                        if (this.listElement) {
                            this.listElement.classList.add('is-hidden');
                        }

                        if (this.emptyElement) {
                            this.emptyElement.classList.add('is-hidden');
                        }

                        if (this.endElement) {
                            this.endElement.classList.add('is-hidden');
                        }

                        if (this.triggerElement) {
                            this.triggerElement.classList.add('is-hidden');
                        }

                        if (this.loadingElement) {
                            this.loadingElement.classList.remove('is-hidden');
                        }

                        this.root.classList.add('is-replacing');
                    }
                }, {
                    key: "hideReplacingState",
                    value: function hideReplacingState() {
                        if (this.listElement) {
                            this.listElement.classList.remove('is-hidden');
                        }

                        this.root.classList.remove('is-replacing');
                    }
                }, {
                    key: "startLoadingProgress",
                    value: function startLoadingProgress() {
                        if (!this.loadingProgressFillElement) {
                            return;
                        }

                        this.stopLoadingProgress();

                        this.loadingProgressFillElement.style.width = '0%';
                        this.loadingProgressStartedAt = performance.now();

                        var duration = 10000;
                        var animate = function (timestamp) {
                            var elapsed = timestamp - this.loadingProgressStartedAt;
                            var progress = Math.min(elapsed / duration, 1);
                            this.loadingProgressFillElement.style.width = String(progress * 100) + '%';

                            if (progress < 1) {
                                this.loadingProgressFrameId = window.requestAnimationFrame(animate);
                            }
                        }.bind(this);

                        this.loadingProgressFrameId = window.requestAnimationFrame(animate);
                    }
                }, {
                    key: "stopLoadingProgress",
                    value: function stopLoadingProgress() {
                        if (this.loadingProgressFrameId) {
                            window.cancelAnimationFrame(this.loadingProgressFrameId);
                            this.loadingProgressFrameId = null;
                        }

                        if (this.loadingProgressFillElement) {
                            this.loadingProgressFillElement.style.width = '0%';
                        }
                    }
                }, {
                    key: "loadMore",
                    value: function loadMore() {
                        if (this.isLoading || !this.hasMore || !this.listUrl) {
                            return;
                        }

                        this.fetchReviews(false);
                    }
                }, {
                    key: "updateLoadState",
                    value: function updateLoadState() {
                        if (this.triggerElement) {
                            this.triggerElement.classList.toggle('is-hidden', !this.hasMore);
                        }

                        if (this.endElement) {
                            this.endElement.classList.toggle('is-hidden', this.hasMore);
                        }

                        if (!this.hasMore && this.observer && this.triggerElement) {
                            this.observer.unobserve(this.triggerElement);
                        }

                        if (this.hasMore && this.observer && this.triggerElement) {
                            this.observer.observe(this.triggerElement);
                        }
                    }
                }, {
                    key: "updateEmptyState",
                    value: function updateEmptyState() {
                        if (!this.emptyElement || !this.listElement) {
                            return;
                        }

                        var isEmpty = !this.listElement.children.length;
                        this.emptyElement.classList.toggle('is-hidden', !isEmpty);
                    }
                }]);

                return ReviewsPage;
            }();

            function initReviewsPage() {
                var root = document.getElementById('reviews-page');
                if (!root) {
                    return;
                }

                if (root.dataset.inited === '1') {
                    return;
                }

                new ReviewsPage(root);
                root.dataset.inited = '1';
            }

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', initReviewsPage);
            } else {
                initReviewsPage();
            }
        })();
    }, {}] }, {}, [1]);